import { render, staticRenderFns } from "./LPGEmissionTable.vue?vue&type=template&id=24c9302d&scoped=true"
import script from "./LPGEmissionTable.vue?vue&type=script&lang=js"
export * from "./LPGEmissionTable.vue?vue&type=script&lang=js"
import style0 from "./LPGEmissionTable.vue?vue&type=style&index=0&id=24c9302d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c9302d",
  null
  
)

export default component.exports